require('./hspinner.component.scss');

class HSpinnerController {
  constructor() {
  }
}

export const HSpinnerComponent = {
  template  : require('./hspinner.component.html'),
  bindings  : {
  },
  controller: HSpinnerController,
};



// WEBPACK FOOTER //
// ./src/shared/hspinner.component.js